import { Component, OnInit } from '@angular/core';

import axios from "src/app/Service/axios";

import Chart from 'chart.js/auto';

import { GurdServiceService } from "src/app/Service/gurd-service.service";

import { ActivatedRoute, Router } from "@angular/router";

import { NotificationService } from "src/app/Service/notification.service";

import { OtherService } from "src/app/Service/other.service";

import { FormBuilder, FormGroup } from '@angular/forms';

import Map from 'ol/Map';
import View from 'ol/View';
import * as olProj from 'ol/proj';
import VectorLayer from 'ol/layer/Vector';
import {
  DragRotateAndZoom,
  defaults as defaultInteractions,
} from 'ol/interaction';
import Feature from 'ol/Feature';
import { Tile as TileLayer } from 'ol/layer';
import OSM from 'ol/source/OSM';

import { Point } from "ol/geom";
import { BingMaps, Cluster, Vector, XYZ } from "ol/source";

import AnimatedCluster from "ol-ext/layer/AnimatedCluster";
import SelectCluster from "ol-ext/interaction/SelectCluster";
import { Tile } from "ol/layer";
import { Circle, Fill, Stroke, Style, Text } from "ol/style";
import { MapService } from "src/app/Service/map.service";
import VectorSource from 'ol/source/Vector';

declare let $: any;

@Component({

  selector: 'app-ayab-zahab-dashboard',

  templateUrl: './ayab-zahab-dashboard.component.html',

  styleUrls: ['./ayab-zahab-dashboard.component.css']

})

export class AyabZahabDashboardComponent implements OnInit {

  lst_Status1: any[];

  lst_Status2: any[];

  lst_Status3: any[];

  lst_Current_Passenger: any[];

  map: any = {};

  location: any = [51.3833554, 35.6770113];

  mdl_Chart: FormGroup = this._fb.group({

    iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

    strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

    tiStatus: 0

  })

  CHART_COLORS3: any = {

    green: 'rgb(111, 255, 111)',

    purple: 'rgb(255, 153, 204)',

    blue: 'rgb(29, 179, 214)',

    orange: 'rgb(45, 103, 103)',

    yellow: 'rgb(251, 101, 150)',

    red: 'rgb(36, 123, 46)',

    grey: 'rgb(103, 13, 183)',

  };

  vector: any;

  source: any;

  layers: any = [];

  private bOfflineMap: boolean = (<any>window).bOfflineMap;

  private strMapUrl: string = (<any>window).strMapUrl;

  constructor(

    private Notification: NotificationService,

    private otherService: OtherService,

    private gurdService: GurdServiceService,

    private _fb: FormBuilder,

    private mapService: MapService,

  ) { }

  ngOnInit(): void {

    this.initialCharts()


  }

  async initialCharts() {

    var model = this.otherService.stringNumberToNumber({

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      tiStatus: 1

    })

    this.otherService.Showspinner();

    await this.getToDaySchdeule(model);

    await this.route_Analysis(model);

    await this.route_ServicesStatus(model, 1);

    await this.route_ServicesStatus(model, 2);

    await this.route_ServicesStatus(model, 3);

    await this.route_Current_Passenger(model);

    this.otherService.nonespinner()

  }

  async getToDaySchdeule(model: any) {

    let res = JSON.parse(((await axios.post(`Route_Dashboard_ToDaySchdeule`, model)).data.toString()));

    if (res.iResult == -1) return this.Notification.showError(res.strError)

    let label: Array<any> = [];

    let datachart: Array<any> = [];

    res.forEach((element: any) => {

      label.push(element.X);

      datachart.push(element.Y);

    });

    var canvas = document.getElementById("myChart1") as any;

    var ctx = canvas.getContext("2d");

    const data = {

      labels: label,

      datasets: [

        {
          data: datachart,

          backgroundColor: Object.values(this.CHART_COLORS3),

        },

      ],

    } as any;

    new Chart(ctx, {

      type: 'pie',

      data: data,

      options: {

        responsive: true,

        interaction: {
          mode: 'nearest',
          intersect: false
        },

        plugins: {

          legend: {

            position: 'top',

            labels: {

              color: "black",

            }

          },

          title: {

            display: false,

          },

        },

      },

    });

    var chartEl = document.getElementById("myChart1") as any;

    chartEl.height = 200;

  }

  async route_Analysis(model: any) {

    let res = JSON.parse(((await axios.post(`Route_FunctionReport_Analysis4Dashboard`, model)).data.toString()));

    if (res.iResult == -1) return this.Notification.showError(res.strError)


  }

  async route_ServicesStatus(model: any, tiStatus: number = 1) {

    model.tiStatus = tiStatus;

    let res = JSON.parse(((await axios.post(`Route_Dashboard_ServicesStatus`, model)).data.toString()));

    if (res.iResult == -1) return this.Notification.showError(res.strError);

    const lst_Name = `lst_Status${tiStatus}`;

    this[lst_Name] = res;

  }

  async route_Current_Passenger(model: any) {

    let res = JSON.parse(((await axios.post(`Route_Current_Passenger_Dashboard`, model)).data.toString()));

    if (res.iResult == -1) return this.Notification.showError(res.strError)

    this.lst_Current_Passenger = res;

    setTimeout(() => {

      this.source = new VectorSource({ wrapX: false });

      this.vector = new VectorLayer({

        source: this.source,

      });

      if (this.bOfflineMap) {

        this.layers.push(

          new TileLayer({

            source: new XYZ({

              url: this.strMapUrl,

              attributions: 'Map data © RayanAndishehNasr' // 

            }),

          })

        );
      }

      else {

        const styles = [

          'AerialWithLabelsOnDemand',

        ];

        let i, ii;

        for (i = 0, ii = styles.length; i < ii; ++i) {
          this.layers.push(
            new TileLayer({
              visible: false,
              preload: Infinity,
              source: new BingMaps({
                key: 'Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j',

                imagerySet: styles[i],
              }),

            }),
          );
        }

        this.layers.push(new TileLayer({ source: new OSM({}) }), this.vector)
      }

      this.map = new Map({

        target: "test",

        view: new View({

          zoom: 4,

          center: olProj.fromLonLat(this.location)

        }),

        layers: this.layers

      });

      this.clustersLayer(res);

    }, 300);

  }

  clustersLayer(data: any) {
    setTimeout(() => {
      this.map.on('click', (e: any) => {
        if (e.dragging) {
          //...
          return;
        }

        var el = this.mapService.mapPointerMove(
          this.map.getEventPixel(e.originalEvent),
          this.map
        );
        // this.showData(el);
        $("#link").click(() => {
          var tooltip = $('#map_tooltip');
          tooltip.tooltip('hide');

        });
      });
      this.map.getView().on('propertychange', function (e: any) {
        var tooltip = $('#map_tooltip');
        tooltip.tooltip('hide');
      });
    }, 200);
    // Cluster Source
    var clusterSource = new Cluster({
      distance: 40,
      source: new Vector()
    }) as any;

    // Addfeatures to the cluster
    let addFeatures = (nb: any) => {
      var ext = this.map.getView().calculateExtent(this.map.getSize());
      var features = [];

      for (var i = 0; i < data.length; ++i) {
        features[i] = new Feature({
          type: 'removable',
          geometry: new Point(this.mapService.transformCoordinates2([
            data[i].fLon,
            data[i].fLat])

          ),
          id_: data[i].strUnitId,
          data: {
            Id: data[i].strUnitId,
            ...data[i]
          },
        });
        features[i].set("id", i);
      }
      clusterSource.getSource().clear();
      clusterSource.getSource().addFeatures(features);


    }

    // Style for the clusters
    var styleCache = {} as any;
    function getStyle(feature: any, resolution: any) {
      var size = feature.get("features").length;
      var style = styleCache[size];
      if (!style) {
        var color = size > 25 ? "192,0,0" : size > 8 ? "255,128,0" : "0,128,0";
        var radius = Math.max(8, Math.min(size * 0.75, 20));
        var dash = (2 * Math.PI * radius) / 6;
        var dashs = [0, dash, dash, dash, dash, dash, dash];
        style = styleCache[size] = new Style({
          image: new Circle({
            radius: radius,
            stroke: new Stroke({
              color: "rgba(" + color + ",0.5)",
              width: 15,
              lineDash: dashs,
              lineCap: "butt"
            }),
            fill: new Fill({
              color: "rgba(" + color + ",1)"
            })
          }),
          text: new Text({
            text: size.toString(),
            fill: new Fill({
              color: "#fff"
            })
          })
        });
      }
      return style;
    }

    // Animated cluster layer
    var clusterLayer = new AnimatedCluster({
      //name: "Cluster",
      source: clusterSource,
      animationDuration: 700,
      // Cluster style
      style: getStyle
    });
    this.map.addLayer(clusterLayer);
    // add 2000 features
    addFeatures(2000);

    var style1 = new Style({
      image: new Circle({
        radius: 5,
        stroke: new Stroke({
          color: "rgba(128,0,0,0.8)",
          width: 2
        }),
        fill: new Fill({
          color: "rgba(128,0,0,0.8)"
        })
      }),
      // Draw a link beetween points (or not)
      stroke: new Stroke({
        color: "#fff",
        width: 1
      })
    });
    // Select interaction to spread cluster out and select features
    var selectCluster = new SelectCluster({
      // Point radius: to calculate distance between the features
      pointRadius: 7,
      animate: true,
      // Feature style when it springs apart
      featureStyle: function () {
        return [style1];
      },
      // selectCluster: false,	// disable cluster selection
      // Style to draw cluster when selected
      style: function (f, res) {
        var cluster = f.get("features");
        if (cluster.length > 1) {
          return getStyle(f, res);
        } else {
          return [
            new Style({
              image: new Circle({
                stroke: new Stroke({
                  color: "rgba(0,0,192,0.5)",
                  width: 2
                }),
                fill: new Fill({ color: "rgba(0,0,192,0.3)" }),
                radius: 5
              })
            })
          ];
        }
      }
    });
    this.map.addInteraction(selectCluster);


  }

}
